module.exports = __webpack_public_path__ + "static/img/common_sports.e959e07.jpg";